import React, { useState, useEffect } from 'react';

function Header({ onNewGuide, onOpenGuide, onSaveGuide, onExportPDF, onExportWord, onOpenSettings, onStartPresentation, studyGuide }) {
  const [showExportMenu, setShowExportMenu] = useState(false);
  const [appInfo, setAppInfo] = useState(null);

  useEffect(() => {
    // Get app info
    if (window.electronAPI) {
      window.electronAPI.getAppInfo().then(setAppInfo);
    }
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.export-dropdown')) {
        setShowExportMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <h1>Bible Study Guide Creator</h1>
          {studyGuide?.title && (
            <div className="guide-info">
              <span className="guide-title">{studyGuide.title}</span>
              {studyGuide.isModified && <span className="modified-indicator">•</span>}
              <span className="last-saved">
                {studyGuide.lastModified ? `Last modified: ${studyGuide.lastModified.toLocaleTimeString()}` : ''}
              </span>
            </div>
          )}
        </div>
        <div className="header-info">
          {appInfo && <span className="version">v{appInfo.version}</span>}
          <span className="status">{studyGuide?.isModified ? 'Unsaved changes' : 'Ready'}</span>
        </div>
      </div>

      <div className="modern-toolbar">
        <div className="toolbar-section">
          <button className="modern-btn" onClick={onNewGuide} title="New Study Guide (Ctrl+N)">
            <span className="btn-icon">📄</span>
            <span className="btn-label">New</span>
          </button>
          <button className="modern-btn" onClick={onOpenGuide} title="Open Study Guide (Ctrl+O)">
            <span className="btn-icon">📂</span>
            <span className="btn-label">Open</span>
          </button>
          <button
            className={`modern-btn ${studyGuide?.isModified ? 'modified' : ''}`}
            onClick={onSaveGuide}
            title="Save Study Guide (Ctrl+S)"
          >
            <span className="btn-icon">💾</span>
            <span className="btn-label">{studyGuide?.isModified ? 'Save*' : 'Save'}</span>
          </button>
        </div>

        <div className="toolbar-separator"></div>

        <div className="toolbar-section">
          <div className="export-dropdown">
            <button
              className="modern-btn"
              onClick={() => setShowExportMenu(!showExportMenu)}
              title="Export Options"
            >
              <span className="btn-icon">📤</span>
              <span className="btn-label">Export</span>
              <span className="dropdown-arrow">⌄</span>
            </button>
            {showExportMenu && (
              <div className="modern-dropdown">
                <button className="dropdown-item" onClick={() => { onExportPDF(); setShowExportMenu(false); }}>
                  <span className="dropdown-icon">📄</span>
                  <span>Export as PDF</span>
                </button>
                <button className="dropdown-item" onClick={() => { onExportWord(); setShowExportMenu(false); }}>
                  <span className="dropdown-icon">📝</span>
                  <span>Export as Word</span>
                </button>
                <button className="dropdown-item" onClick={() => { setShowExportMenu(false); }}>
                  <span className="dropdown-icon">🌐</span>
                  <span>Export as HTML</span>
                </button>
              </div>
            )}
          </div>

          <button
            className="modern-btn"
            onClick={onStartPresentation}
            title="Start Presentation Mode (F5)"
          >
            <span className="btn-icon">📺</span>
            <span className="btn-label">Present</span>
          </button>

          <button className="modern-btn" onClick={onOpenSettings} title="Settings (Ctrl+,)">
            <span className="btn-icon">⚙️</span>
            <span className="btn-label">Settings</span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;